import React, { useState, useEffect } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import DatePicker from '../../../components/utils/datepicker';
import MonthPicker from '../../../components/utils/monthpicker';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaFilter, FaFileExcel } from 'react-icons/fa';
import Paginacao from '../../../components/utils/paginacao';

const Relatorios = () => {
    const [activeTab, setActiveTab] = useState('fluxo-caixa');

    const [fluxoCaixaData, setFluxoCaixaData] = useState([]);
    const [fluxoCaixaFiltros, setFluxoCaixaFiltros] = useState({
        data_ini: null,
        data_fim: null,
        contas_bancarias: [],
        classe_fluxo_caixa: '',
        unidade_id: { value: 'todas', label: 'Todas as unidades' }
    });
    const [fluxoCaixaCurrentPage, setFluxoCaixaCurrentPage] = useState(1);
    const [fluxoCaixaTotalPages, setFluxoCaixaTotalPages] = useState(1);
    const [fluxoCaixaTotalRegistros, setFluxoCaixaTotalRegistros] = useState(0);
    const [totalEntradas, setTotalEntradas] = useState(0);
    const [totalSaidas, setTotalSaidas] = useState(0);
    const limit = 10;

    const [dreData, setDreData] = useState([]);
    const [dreFiltros, setDreFiltros] = useState({
        competencia_ini: '',
        competencia_fim: '',
        unidade_id: { value: 'todas', label: 'Todas as unidades' }
    });
    const [dreCurrentPage, setDreCurrentPage] = useState(1);
    const [dreTotalPages, setDreTotalPages] = useState(1);
    const [dreTotalRegistros, setDreTotalRegistros] = useState(0);

    const [balancoData, setBalancoData] = useState([]);
    const [balancoCurrentPage, setBalancoCurrentPage] = useState(1);
    const [balancoTotalPages, setBalancoTotalPages] = useState(1);
    const [balancoTotalRegistros, setBalancoTotalRegistros] = useState(0);
    const [balancoFiltros, setBalancoFiltros] = useState({
        unidade_id: { value: 'todas', label: 'Todas as unidades' }
    });

    const [doarData, setDoarData] = useState([]);
    const [doarFiltros, setDoarFiltros] = useState({
        competencia_ini: '',
        competencia_fim: '',
        unidade_id: { value: 'todas', label: 'Todas as unidades' }
    });
    const [doarCurrentPage, setDoarCurrentPage] = useState(1);
    const [doarTotalPages, setDoarTotalPages] = useState(1);
    const [doarTotalRegistros, setDoarTotalRegistros] = useState(0);

    const [contasBancarias, setContasBancarias] = useState([]);
    const [unidades, setUnidades] = useState([]);
    const [usuarioLogado, setUsuarioLogado] = useState(null);

    useEffect(() => {
        fetchContasBancarias();
        fetchUnidades();
        fetchUsuarioLogado();
    }, []);

    useEffect(() => {
        if (fluxoCaixaData.length > 0) {
            fetchFluxoCaixa();
        }
    }, [fluxoCaixaCurrentPage]);

    useEffect(() => {
        if (balancoData.length > 0) {
            fetchBalanco();
        }
    }, [balancoCurrentPage]);

    useEffect(() => {
        if (dreData.length > 0) {
            fetchDre();
        }
    }, [dreCurrentPage]);

    useEffect(() => {
        if (doarData.length > 0) {
            fetchDoar();
        }
    }, [doarCurrentPage]);

    useEffect(() => {
        if (activeTab === 'fluxo-caixa') {
            fetchFluxoCaixa();
        } else if (activeTab === 'dre') {
            fetchDre();
        } else if (activeTab === 'balanco') {
            fetchBalanco();
        } else if (activeTab === 'doar') {
            fetchDoar();
        }
    }, [activeTab]);

    useEffect(() => {
        if (usuarioLogado && unidades.length > 0) {
            const unidadeUsuario = usuarioLogado.dadosColaborador?.unidade_designacao_id;
            if (unidadeUsuario) {
                const unidadeEncontrada = unidades.find(u => u.id === unidadeUsuario);
                if (unidadeEncontrada) {
                    setBalancoFiltros(prev => ({
                        ...prev,
                        unidade_id: {
                            value: unidadeEncontrada.id,
                            label: unidadeEncontrada.nome
                        }
                    }));
                    setFluxoCaixaFiltros(prev => ({
                        ...prev,
                        unidade_id: {
                            value: unidadeEncontrada.id,
                            label: unidadeEncontrada.nome
                        }
                    }));
                    setDreFiltros(prev => ({
                        ...prev,
                        unidade_id: {
                            value: unidadeEncontrada.id,
                            label: unidadeEncontrada.nome
                        }
                    }));
                    setDoarFiltros(prev => ({
                        ...prev,
                        unidade_id: {
                            value: unidadeEncontrada.id,
                            label: unidadeEncontrada.nome
                        }
                    }));
                }
            }
        }
    }, [usuarioLogado, unidades]);

    const fetchContasBancarias = async () => {
        try {
            const response = await api.get('/contas-bancarias');
            setContasBancarias(response.data.records || []);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar contas bancárias', 'error');
        }
    };

    const fetchUnidades = async () => {
        try {
            const response = await api.get('/unidades?limit=1000');
            setUnidades(response.data.unidades || []);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar unidades', 'error');
        }
    };

    const fetchUsuarioLogado = async () => {
        try {
            const response = await api.get('/pessoas/me');
            setUsuarioLogado(response.data);
        } catch (error) {
            console.error('Erro ao carregar dados do usuário:', error);
        }
    };

    const handleFiltroChange = (filtros, setFiltros) => (e) => {
        const { name, value } = e.target;
        setFiltros(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const convertToISO = (date) => {
        if (!date) return '';
        if (date instanceof Date) {
            return date.toISOString().split('T')[0];
        }
        if (typeof date === 'string' && date.includes('-')) {
            return date;
        }
        if (typeof date === 'string' && date.length === 10) {
            const [dia, mes, ano] = date.split('/');
            return `${ano}-${mes}-${dia}`;
        }
        return '';
    };

    const formatarValor = (valor) => {
        if (!valor) return 'R$ 0,00';
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    const formatarData = (dataString) => {
        if (!dataString) return '-';
        const data = new Date(dataString + 'T00:00:00');
        return data.toLocaleDateString('pt-BR');
    };

    const formatarCompetencia = (dataString) => {
        if (!dataString) return '-';
        const data = new Date(dataString + 'T00:00:00');
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const ano = data.getFullYear();
        return `${mes}/${ano}`;
    };

    const formatarFormaPagamento = (formaPagamento) => {
        if (!formaPagamento) return '-';

        const formasFormatadas = {
            'dinheiro': 'Dinheiro',
            'cartao_credito': 'Cartão de Crédito',
            'cartao_debito': 'Cartão de Débito',
            'pix': 'PIX',
            'transferencia': 'Transferência',
            'boleto': 'Boleto',
            'ted': 'TED',
            'doc': 'DOC',
            'cheque': 'Cheque',
            'deposito': 'Depósito',
            'voucher': 'Voucher',
            'permuta': 'Permuta',
            'cortesia': 'Cortesia',
            'credito_loja': 'Crédito Loja',
            'divida': 'Dívida'
        };

        return formasFormatadas[formaPagamento] || formaPagamento;
    };

    const formatarClasseFluxo = (classe) => {
        if (!classe) return '-';
        const classes = {
            'O': 'Operacional',
            'I': 'Investimento',
            'F': 'Financiamento'
        };
        return classes[classe] || classe;
    };

    const handleContaBancariaChange = (contaId) => {
        setFluxoCaixaFiltros(prev => {
            const contasAtual = [...prev.contas_bancarias];
            if (contasAtual.includes(contaId)) {
                return {
                    ...prev,
                    contas_bancarias: contasAtual.filter(id => id !== contaId)
                };
            } else {
                return {
                    ...prev,
                    contas_bancarias: [...contasAtual, contaId]
                };
            }
        });
    };

    const removerContaBancaria = (contaId) => {
        setFluxoCaixaFiltros(prev => ({
            ...prev,
            contas_bancarias: prev.contas_bancarias.filter(id => id !== contaId)
        }));
    };

    const limparFiltros = () => {
        const unidadeUsuario = usuarioLogado?.dadosColaborador?.unidade_designacao_id;
        let unidadeParaSetar = { value: 'todas', label: 'Todas as unidades' };

        if (unidadeUsuario) {
            const unidadeEncontrada = unidades.find(u => u.id === unidadeUsuario);
            if (unidadeEncontrada) {
                unidadeParaSetar = {
                    value: unidadeEncontrada.id,
                    label: unidadeEncontrada.nome
                };
            }
        }

        setFluxoCaixaFiltros({
            data_ini: null,
            data_fim: null,
            contas_bancarias: [],
            classe_fluxo_caixa: '',
            unidade_id: unidadeParaSetar
        });
        setFluxoCaixaCurrentPage(1);
    };

    const fetchFluxoCaixa = async () => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: fluxoCaixaCurrentPage,
                limit: limit,
                data_ini: convertToISO(fluxoCaixaFiltros.data_ini),
                data_fim: convertToISO(fluxoCaixaFiltros.data_fim),
                contas_bancarias: fluxoCaixaFiltros.contas_bancarias.join(','),
                classe_fluxo_caixa: fluxoCaixaFiltros.classe_fluxo_caixa
            };

            if (fluxoCaixaFiltros.unidade_id?.value && fluxoCaixaFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = fluxoCaixaFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/fluxo-caixa', { params });

            setFluxoCaixaData(response.data.records || []);
            setFluxoCaixaTotalRegistros(response.data.totalRegistros || 0);
            setFluxoCaixaTotalPages(response.data.totalPaginas || 1);
            setTotalEntradas(response.data.totalEntradas || 0);
            setTotalSaidas(response.data.totalSaidas || 0);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao gerar relatório', 'error');
        }
    };

    const fetchDre = async () => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: dreCurrentPage,
                limit: limit,
                competencia_ini: convertToISO(dreFiltros.competencia_ini),
                competencia_fim: convertToISO(dreFiltros.competencia_fim)
            };

            if (dreFiltros.unidade_id?.value && dreFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = dreFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/dre', { params });

            setDreData(response.data.records || []);
            setDreTotalRegistros(response.data.totalRegistros || 0);
            setDreTotalPages(response.data.totalPaginas || 1);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao gerar relatório', 'error');
        }
    };

    const fetchBalanco = async () => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: balancoCurrentPage,
                limit: limit
            };

            if (balancoFiltros.unidade_id?.value && balancoFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = balancoFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/balanco', { params });

            setBalancoData(response.data.records || []);
            setBalancoTotalRegistros(response.data.totalRegistros || 0);
            setBalancoTotalPages(response.data.totalPaginas || 1);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao gerar relatório', 'error');
        }
    };

    const fetchDoar = async () => {
        try {
            Swal.fire({
                title: 'Carregando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                page: doarCurrentPage,
                limit: limit,
                competencia_ini: convertToISO(doarFiltros.competencia_ini),
                competencia_fim: convertToISO(doarFiltros.competencia_fim)
            };

            if (doarFiltros.unidade_id?.value && doarFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = doarFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/doar', { params });
            setDoarData(response.data.records || []);
            setDoarTotalRegistros(response.data.totalRegistros || 0);
            setDoarTotalPages(response.data.totalPaginas || 1);
            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao gerar relatório', 'error');
        }
    };

    const exportFluxoCaixa = async () => {
        try {
            Swal.fire({
                title: 'Exportando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                data_ini: convertToISO(fluxoCaixaFiltros.data_ini),
                data_fim: convertToISO(fluxoCaixaFiltros.data_fim),
                contas_bancarias: fluxoCaixaFiltros.contas_bancarias.join(','),
                classe_fluxo_caixa: fluxoCaixaFiltros.classe_fluxo_caixa
            };

            if (fluxoCaixaFiltros.unidade_id?.value && fluxoCaixaFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = fluxoCaixaFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/fluxo-caixa/export', {
                params,
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'fluxo-caixa.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao exportar relatório', 'error');
        }
    };

    const exportDre = async () => {
        try {
            Swal.fire({
                title: 'Exportando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                competencia_ini: convertToISO(dreFiltros.competencia_ini),
                competencia_fim: convertToISO(dreFiltros.competencia_fim)
            };

            if (dreFiltros.unidade_id?.value && dreFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = dreFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/dre/export', {
                params,
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'dre.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao exportar relatório', 'error');
        }
    };

    const exportBalanco = async () => {
        try {
            Swal.fire({
                title: 'Exportando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {};

            if (balancoFiltros.unidade_id?.value && balancoFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = balancoFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/balanco/export', {
                params,
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'balanco-gerencial.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao exportar relatório', 'error');
        }
    };

    const exportDoar = async () => {
        try {
            Swal.fire({
                title: 'Exportando...',
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const params = {
                competencia_ini: convertToISO(doarFiltros.competencia_ini),
                competencia_fim: convertToISO(doarFiltros.competencia_fim)
            };

            if (doarFiltros.unidade_id?.value && doarFiltros.unidade_id.value !== 'todas') {
                params.unidade_id = doarFiltros.unidade_id.value;
            }

            const response = await api.get('/relatorios/doar/export', {
                params,
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'doar.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

            Swal.close();
        } catch (error) {
            Swal.fire('Erro', 'Erro ao exportar relatório', 'error');
        }
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <h4 className="fw-bold">Relatórios Financeiros</h4>
                        </div>
                    </div>

                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="mb-3 mt-4"
                    >
                        <Tab eventKey="fluxo-caixa" title="Fluxo de Caixa">
                            <div className="row mt-4 mb-4">
                                <div className="col-lg-2 col-12">
                                    <label className="form-label fw-bold">Data De</label>
                                    <DatePicker
                                        selected={fluxoCaixaFiltros.data_ini}
                                        onChange={(date) => setFluxoCaixaFiltros(prev => ({ ...prev, data_ini: date }))}
                                    />
                                </div>
                                <div className="col-lg-2 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Data Até</label>
                                    <DatePicker
                                        selected={fluxoCaixaFiltros.data_fim}
                                        onChange={(date) => setFluxoCaixaFiltros(prev => ({ ...prev, data_fim: date }))}
                                    />
                                </div>
                                <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Unidade</label>
                                    <select
                                        className="form-control"
                                        value={fluxoCaixaFiltros.unidade_id?.value || 'todas'}
                                        onChange={(e) => setFluxoCaixaFiltros(prev => ({
                                            ...prev,
                                            unidade_id: {
                                                value: e.target.value,
                                                label: e.target.options[e.target.selectedIndex].text
                                            }
                                        }))}
                                        disabled={usuarioLogado?.dadosColaborador?.unidade_designacao_id}
                                    >
                                        <option value="todas">Todas as unidades</option>
                                        {unidades.map(unidade => (
                                            <option key={unidade.id} value={unidade.id}>
                                                {unidade.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-2 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Contas Bancárias</label>
                                    <div className="dropdown position-relative">
                                        <div
                                            className="form-control d-flex flex-wrap align-items-center gap-1"
                                            style={{ minHeight: '38px', cursor: 'pointer', paddingRight: '30px' }}
                                            data-bs-toggle="dropdown"
                                        >
                                            {fluxoCaixaFiltros.contas_bancarias.length === 0 ? (
                                                <span className="text-muted">Todas as contas selecionadas</span>
                                            ) : (
                                                fluxoCaixaFiltros.contas_bancarias.map(contaId => {
                                                    const conta = contasBancarias.find(c => c.id === contaId);
                                                    return conta ? (
                                                        <span key={contaId} className="badge d-flex align-items-baseline" style={{ backgroundColor: '#172228', color: '#fff' }}>
                                                            <span style={{ fontSize: '0.8em' }}>
                                                                {conta.nome_exibicao || conta.nome}
                                                            </span>
                                                            <button
                                                                type="button"
                                                                className="btn-close btn-close-white ms-1"
                                                                style={{ fontSize: '0.6em' }}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    removerContaBancaria(contaId);
                                                                }}
                                                            ></button>
                                                        </span>
                                                    ) : null;
                                                })
                                            )}
                                        </div>
                                        <i
                                            className="fas fa-chevron-down position-absolute text-muted"
                                            style={{ top: '50%', right: '10px', transform: 'translateY(-50%)', pointerEvents: 'none' }}
                                        ></i>
                                        <ul className="dropdown-menu w-100" onClick={(e) => e.stopPropagation()}>
                                            <li>
                                                <button
                                                    className="dropdown-item"
                                                    type="button"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setFluxoCaixaFiltros(prev => ({ ...prev, contas_bancarias: [] }));
                                                    }}
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input me-2"
                                                        checked={fluxoCaixaFiltros.contas_bancarias.length === 0}
                                                        readOnly
                                                    />
                                                    Todas as contas
                                                </button>
                                            </li>
                                            <li><hr className="dropdown-divider" /></li>
                                            {contasBancarias.map(conta => (
                                                <li key={conta.id}>
                                                    <button
                                                        className="dropdown-item"
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleContaBancariaChange(conta.id);
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input me-2"
                                                            checked={fluxoCaixaFiltros.contas_bancarias.includes(conta.id)}
                                                            readOnly
                                                        />
                                                        {conta.nome_exibicao || conta.nome}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                                    <div className="d-flex gap-2 w-100 justify-content-end">
                                        <button className="btn btn-outline-secondary" onClick={limparFiltros}>
                                            Limpar
                                        </button>
                                        <button className="btn btn-custom-primary" onClick={fetchFluxoCaixa}>
                                            <FaFilter className="me-1" /> Filtrar
                                        </button>
                                        <button className="btn btn-success" onClick={exportFluxoCaixa}>
                                            <FaFileExcel className="me-1" /> Exportar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="row mb-3">
                                <div className="col-md-3">
                                    <div className="mb-3">
                                        <h5 className="fw-bold text-success d-inline">Entradas</h5>
                                        <div className="mt-2">
                                            <span className="fw-bold me-1">Total:</span>
                                            <span className="fw-bold text-success">{formatarValor(totalEntradas)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="mb-3">
                                        <h5 className="fw-bold text-danger d-inline">Saídas</h5>
                                        <div className="mt-2">
                                            <span className="fw-bold me-1">Total:</span>
                                            <span className="fw-bold text-danger">{formatarValor(totalSaidas)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Data</th>
                                            <th>Categoria</th>
                                            <th>Conta</th>
                                            <th>Descrição</th>
                                            <th>Forma Pagamento</th>
                                            <th>Entrada</th>
                                            <th>Saída</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fluxoCaixaData.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    Nenhum movimento encontrado.
                                                </td>
                                            </tr>
                                        ) : (
                                            fluxoCaixaData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{formatarData(item.data_movimento)}</td>
                                                    <td className="text-nowrap">{item.categoria}</td>
                                                    <td className="text-nowrap">{item.conta_bancaria || '-'}</td>
                                                    <td>{item.descricao || '-'}</td>
                                                    <td className="text-nowrap">{formatarFormaPagamento(item.forma_pagamento)}</td>
                                                    <td className="text-success">{formatarValor(item.entrada)}</td>
                                                    <td className="text-danger">{formatarValor(item.saida)}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {fluxoCaixaTotalRegistros > 0 && (
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <span>
                                        Total de registros: <strong>{fluxoCaixaTotalRegistros}</strong>
                                    </span>
                                    <Paginacao
                                        currentPage={fluxoCaixaCurrentPage}
                                        totalPages={fluxoCaixaTotalPages}
                                        onPageChange={(page) => {
                                            setFluxoCaixaCurrentPage(page);
                                        }}
                                    />
                                </div>
                            )}
                        </Tab>

                        <Tab eventKey="dre" title="DRE">
                            <div className="row mt-4 mb-4">
                                <div className="col-lg-2 col-12">
                                    <label className="form-label fw-bold">Competência De</label>
                                    <MonthPicker
                                        selected={dreFiltros.competencia_ini}
                                        onChange={(date) => setDreFiltros(prev => ({ ...prev, competencia_ini: date }))}
                                    />
                                </div>
                                <div className="col-lg-2 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Competência Até</label>
                                    <MonthPicker
                                        selected={dreFiltros.competencia_fim}
                                        onChange={(date) => setDreFiltros(prev => ({ ...prev, competencia_fim: date }))}
                                    />
                                </div>
                                <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Unidade</label>
                                    <select
                                        className="form-control"
                                        value={dreFiltros.unidade_id?.value || 'todas'}
                                        onChange={(e) => setDreFiltros(prev => ({
                                            ...prev,
                                            unidade_id: {
                                                value: e.target.value,
                                                label: e.target.options[e.target.selectedIndex].text
                                            }
                                        }))}
                                        disabled={usuarioLogado?.dadosColaborador?.unidade_designacao_id}
                                    >
                                        <option value="todas">Todas as unidades</option>
                                        {unidades.map(unidade => (
                                            <option key={unidade.id} value={unidade.id}>
                                                {unidade.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-5 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                                    <div className="d-flex gap-2 w-100 justify-content-end">
                                        <button className="btn btn-outline-secondary" onClick={() => {
                                            const unidadeUsuario = usuarioLogado?.dadosColaborador?.unidade_designacao_id;
                                            let unidadeParaSetar = { value: 'todas', label: 'Todas as unidades' };

                                            if (unidadeUsuario) {
                                                const unidadeEncontrada = unidades.find(u => u.id === unidadeUsuario);
                                                if (unidadeEncontrada) {
                                                    unidadeParaSetar = {
                                                        value: unidadeEncontrada.id,
                                                        label: unidadeEncontrada.nome
                                                    };
                                                }
                                            }

                                            setDreFiltros({
                                                competencia_ini: '',
                                                competencia_fim: '',
                                                unidade_id: unidadeParaSetar
                                            });
                                            setDreCurrentPage(1);
                                        }}>
                                            Limpar
                                        </button>
                                        <button className="btn btn-custom-primary" onClick={fetchDre}>
                                            <FaFilter className="me-1" /> Filtrar
                                        </button>
                                        <button className="btn btn-success" onClick={exportDre}>
                                            <FaFileExcel className="me-1" /> Exportar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Competência</th>
                                            <th>Grupo DRE</th>
                                            <th>Categoria</th>
                                            <th>Receitas</th>
                                            <th>Despesas</th>
                                            <th>Resultado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dreData.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    Nenhum dado encontrado para o DRE.
                                                </td>
                                            </tr>
                                        ) : (
                                            dreData.map((item, index) => {
                                                const receitas = parseFloat(item.receitas) || 0;
                                                const despesas = parseFloat(item.despesas) || 0;
                                                const despesasExibicao = despesas > 0 ? -despesas : despesas;
                                                const resultado = receitas - despesas;

                                                return (
                                                    <tr key={index}>
                                                        <td>{formatarCompetencia(item.competencia)}</td>
                                                        <td>{item.grupo_dre || '-'}</td>
                                                        <td>{item.categoria}</td>
                                                        <td>{formatarValor(receitas)}</td>
                                                        <td className={despesas > 0 ? 'text-danger' : ''}>{formatarValor(despesasExibicao)}</td>
                                                        <td className={resultado >= 0 ? 'text-success' : 'text-danger'}>
                                                            {formatarValor(resultado)}
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {dreTotalRegistros > 0 && (
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <span>
                                        Total de registros: <strong>{dreTotalRegistros}</strong>
                                    </span>
                                    <Paginacao
                                        currentPage={dreCurrentPage}
                                        totalPages={dreTotalPages}
                                        onPageChange={(page) => {
                                            setDreCurrentPage(page);
                                        }}
                                    />
                                </div>
                            )}
                        </Tab>

                        <Tab eventKey="balanco" title="Balanço Gerencial">
                            <div className="row mt-4 mb-4">
                                <div className="col-lg-3 col-12">
                                    <label className="form-label fw-bold">Unidade</label>
                                    <select
                                        className="form-control"
                                        value={balancoFiltros.unidade_id?.value || 'todas'}
                                        onChange={(e) => setBalancoFiltros(prev => ({
                                            ...prev,
                                            unidade_id: {
                                                value: e.target.value,
                                                label: e.target.options[e.target.selectedIndex].text
                                            }
                                        }))}
                                        disabled={usuarioLogado?.dadosColaborador?.unidade_designacao_id}
                                    >
                                        <option value="todas">Todas as unidades</option>
                                        {unidades.map(unidade => (
                                            <option key={unidade.id} value={unidade.id}>
                                                {unidade.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-9 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                                    <div className="d-flex gap-2 w-100 justify-content-end">
                                        <button className="btn btn-outline-secondary" onClick={() => {
                                            const unidadeUsuario = usuarioLogado?.dadosColaborador?.unidade_designacao_id;
                                            let unidadeParaSetar = { value: 'todas', label: 'Todas as unidades' };

                                            if (unidadeUsuario) {
                                                const unidadeEncontrada = unidades.find(u => u.id === unidadeUsuario);
                                                if (unidadeEncontrada) {
                                                    unidadeParaSetar = {
                                                        value: unidadeEncontrada.id,
                                                        label: unidadeEncontrada.nome
                                                    };
                                                }
                                            }

                                            setBalancoFiltros({ unidade_id: unidadeParaSetar });
                                        }}>
                                            Limpar
                                        </button>
                                        <button className="btn btn-custom-primary" onClick={fetchBalanco}>
                                            <FaFilter className="me-1" /> Filtrar
                                        </button>
                                        <button className="btn btn-success" onClick={exportBalanco}>
                                            <FaFileExcel className="me-1" /> Exportar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Grupo</th>
                                            <th>Subgrupo</th>
                                            <th>Conta</th>
                                            <th>Unidade</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {balancoData.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    Nenhum dado encontrado para o balanço gerencial.
                                                </td>
                                            </tr>
                                        ) : (
                                            balancoData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.grupo}</td>
                                                    <td>{item.subgrupo}</td>
                                                    <td className="text-nowrap">{item.conta || '-'}</td>
                                                    <td className="text-nowrap">{item.unidade_nome || '-'}</td>
                                                    <td className={item.valor >= 0 ? 'text-success' : 'text-danger'}>
                                                        {formatarValor(item.valor)}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {balancoTotalRegistros > 0 && (
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <span>
                                        Total de registros: <strong>{balancoTotalRegistros}</strong>
                                    </span>
                                    <Paginacao
                                        currentPage={balancoCurrentPage}
                                        totalPages={balancoTotalPages}
                                        onPageChange={(page) => {
                                            setBalancoCurrentPage(page);
                                        }}
                                    />
                                </div>
                            )}
                        </Tab>

                        <Tab eventKey="doar" title="DOAR">
                            <div className="row mt-4 mb-4">
                                <div className="col-lg-2 col-12">
                                    <label className="form-label fw-bold">Competência De</label>
                                    <MonthPicker
                                        selected={doarFiltros.competencia_ini}
                                        onChange={(date) => setDoarFiltros(prev => ({ ...prev, competencia_ini: date }))}
                                    />
                                </div>
                                <div className="col-lg-2 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Competência Até</label>
                                    <MonthPicker
                                        selected={doarFiltros.competencia_fim}
                                        onChange={(date) => setDoarFiltros(prev => ({ ...prev, competencia_fim: date }))}
                                    />
                                </div>
                                <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Unidade</label>
                                    <select
                                        className="form-control"
                                        value={doarFiltros.unidade_id?.value || 'todas'}
                                        onChange={(e) => setDoarFiltros(prev => ({
                                            ...prev,
                                            unidade_id: {
                                                value: e.target.value,
                                                label: e.target.options[e.target.selectedIndex].text
                                            }
                                        }))}
                                        disabled={usuarioLogado?.dadosColaborador?.unidade_designacao_id}
                                    >
                                        <option value="todas">Todas as unidades</option>
                                        {unidades.map(unidade => (
                                            <option key={unidade.id} value={unidade.id}>
                                                {unidade.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-lg-5 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                                    <div className="d-flex gap-2 w-100 justify-content-end">
                                        <button className="btn btn-outline-secondary" onClick={() => {
                                            const unidadeUsuario = usuarioLogado?.dadosColaborador?.unidade_designacao_id;
                                            let unidadeParaSetar = { value: 'todas', label: 'Todas as unidades' };

                                            if (unidadeUsuario) {
                                                const unidadeEncontrada = unidades.find(u => u.id === unidadeUsuario);
                                                if (unidadeEncontrada) {
                                                    unidadeParaSetar = {
                                                        value: unidadeEncontrada.id,
                                                        label: unidadeEncontrada.nome
                                                    };
                                                }
                                            }

                                            setDoarFiltros({
                                                competencia_ini: '',
                                                competencia_fim: '',
                                                unidade_id: unidadeParaSetar
                                            });
                                        }}>
                                            Limpar
                                        </button>
                                        <button className="btn btn-custom-primary" onClick={fetchDoar}>
                                            <FaFilter className="me-1" /> Filtrar
                                        </button>
                                        <button className="btn btn-success" onClick={exportDoar}>
                                            <FaFileExcel className="me-1" /> Exportar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {(() => {
                                let totalOrigemPeriodo = 0;
                                let totalAplicacaoPeriodo = 0;

                                doarData.forEach(item => {
                                    totalOrigemPeriodo += parseFloat(item.origem) || 0;
                                    totalAplicacaoPeriodo += parseFloat(item.aplicacao) || 0;
                                });

                                const totalPeriodo = totalOrigemPeriodo - totalAplicacaoPeriodo;

                                return (
                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <h5 className="fw-bold d-inline">Origem</h5>
                                                <div className="mt-2">
                                                    <span className="fw-bold me-1">Total:</span>
                                                    <span className="fw-bold">{formatarValor(totalOrigemPeriodo)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <h5 className="fw-bold d-inline">Aplicação</h5>
                                                <div className="mt-2">
                                                    <span className="fw-bold me-1">Total:</span>
                                                    <span className="fw-bold">{formatarValor(totalAplicacaoPeriodo)}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="mb-3">
                                                <h5 className={`fw-bold ${totalPeriodo >= 0 ? 'text-success' : 'text-danger'} d-inline`}>Resultado</h5>
                                                <div className="mt-2">
                                                    <span className="fw-bold me-1">Total:</span>
                                                    <span className={`fw-bold ${totalPeriodo >= 0 ? 'text-success' : 'text-danger'}`}>{formatarValor(totalPeriodo)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })()}

                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>Competência</th>
                                            <th>Classe Fluxo</th>
                                            <th>Categoria</th>
                                            <th>Origem</th>
                                            <th>Aplicação</th>
                                            <th>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {doarData.length === 0 ? (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    Nenhum dado encontrado para o DOAR.
                                                </td>
                                            </tr>
                                        ) : (
                                            doarData.map((item, index) => {
                                                const origem = parseFloat(item.origem) || 0;
                                                const aplicacao = parseFloat(item.aplicacao) || 0;
                                                const total = origem - aplicacao;

                                                return (
                                                    <tr key={index}>
                                                        <td>{formatarCompetencia(item.competencia)}</td>
                                                        <td>{formatarClasseFluxo(item.classe_fluxo_caixa)}</td>
                                                        <td>{item.categoria}</td>
                                                        <td>{formatarValor(item.origem)}</td>
                                                        <td>{formatarValor(item.aplicacao)}</td>
                                                        <td className={total >= 0 ? 'text-success' : 'text-danger'}>{formatarValor(total)}</td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <span>
                                    Total de registros: <strong>{doarTotalRegistros}</strong>
                                </span>
                                <Paginacao
                                    currentPage={doarCurrentPage}
                                    totalPages={doarTotalPages}
                                    onPageChange={(page) => {
                                        setDoarCurrentPage(page);
                                    }}
                                />
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
        </div>
    );
};

export default Relatorios;